
class exports.Form extends KoModel

    setInitialDeps: () ->
        super()
        @syncDeps
            'Layer': 'grower::viewmodels/prescription_map/Layer'


    constructor: (handler, data = {}, deps = {}) ->
        super()
        @setInitialDeps()
        @syncDeps(deps)

        @handler    = handler
        @editing    = ko.observable false

        @layer      = ko.observable( new (@getDep 'Layer') this, data )


    setEditing: () ->
        @editing(true)
        @handler.bindForSubmit()


    getHandler: () ->
        return @handler

